module.exports = __webpack_public_path__ + "img/provider-hero.9ae4182f.svg";